/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Japanology17Inputs */

const en__field__enum_additionalstudyinterests_study_japanology17 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Japanology17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanology`)
};

const de__field__enum_additionalstudyinterests_study_japanology17 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Japanology17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanologie`)
};

/**
* | output |
* | --- |
* | "Japanology" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Japanology17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_japanology17 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Japanology17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Japanology17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_japanology17(inputs)
	return de__field__enum_additionalstudyinterests_study_japanology17(inputs)
});
export { _field__enum_additionalstudyinterests_study_japanology17 as "_field__enum_additionalStudyInterests_STUDY_JAPANOLOGY" }